import React from 'react'
import { ArrowCircleUp } from 'iconsax-react'
import { useTheme } from '@mui/material'

import useStyles from './styles'

type ExpansionArrowProps = {
  expanded: boolean
}
const ExpansionArrow: React.FC<ExpansionArrowProps> = ({ expanded }) => {
  const theme = useTheme()

  const classes = useStyles({ expanded })

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <ArrowCircleUp size={theme.size.base} className={classes.icon} />
      </div>
    </div>
  )
}

export default ExpansionArrow
